<template>
  <Steps>
    <SwapableStep>
      <Title :index="4">{{ $t('process.step_4_title') }}</Title>
      <StepText>{{ $t('process.step_4_text_1') }} </StepText>
    </SwapableStep>
  </Steps>
</template>
<script>
import Steps from '../../netherlands/Steps/Index.vue';
import SwapableStep from '../../netherlands/Steps/SwappableStep.vue';
import Title from '../../netherlands/Steps/Title.vue';
import StepText from '../../netherlands/Steps/Text.vue';

export default {
  components: { Steps, SwapableStep, Title, StepText },
};
</script>
